import { DashboardHeaderToolbarComponent } from '@cloud-twin-v2/ct-dashboards/dashboard-header-toolbar/dashboard-header-toolbar.component';
import { PersistencyTypes } from '@common-modules/common-persistency/persistency-types';
import { DynamicLayoutExternalSettings } from '@common-modules/dynamic-layout/dynamic-layout-external-settings';
import { DynamicLayoutItemSettings } from '@common-modules/dynamic-layout/models/dynamic-layout-item-settings';
import { DashboardChildWidgetParams } from '@common-modules/right-panel/dashboards/dashboard-widget-params';
import { RightPanelModule } from '@common-modules/right-panel/right-panel.module';

const isDashboardChildWidget = (itemSettings: DynamicLayoutItemSettings) => {
  return !!(itemSettings.params as DashboardChildWidgetParams)?.dashboardChildId;
};

export const cloudTwinDynamicLayoutExternalSettings: DynamicLayoutExternalSettings = {
  persistency: PersistencyTypes.Backend,
  extendHeaders: [
    {
      component: DashboardHeaderToolbarComponent,
      shouldRender: isDashboardChildWidget,
      flagName: 'dashboard-child-toolbar',
      featureInjectorFn: () => RightPanelModule.injector,
    },
  ],
};
